module.exports = __webpack_public_path__ + "img/img_zhuangshi_nor@2x.1c83c6fe.png";